import { I18n } from 'i18n-js';
import translations from '../locales.json';

const i18n = new I18n(translations);
i18n.locale = window.gon.locale;

export default i18n;
